import { addHexPrefix } from './addHexPrefix';
export const hexlify = input => addHexPrefix(input.toString(16));
